import React, { useState, useEffect } from "react";
import { Box, Typography, Button, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Modal from "react-awesome-modal";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";

const PlayAdModal = ({ ad, visible, setVisible, setPlayAd, downloadBook }) => {
  const [seconds, setSeconds] = useState(30);
  const [showCloseButton, setShowCloseButton] = useState(false);
  const isImageAd = /\.(jpg|jpeg|png|gif)$/i.test(ad?.ad_file);
  const isVideoAd = /\.(mp4|webm|ogg)$/i.test(ad?.ad_file);

  const baseUrl = ad?.redirect_url || '';
  const queryString = new URLSearchParams({
    ad_id: ad?.ad_id,
    book_author: downloadBook?.book?.author?._id,
    download_book: downloadBook?._id,
  }).toString();
  
  const redirect_url = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${queryString}`;
  
  useEffect(() => {
    if (ad) {
      setSeconds(30); // Reset the countdown
      setShowCloseButton(false); // Reset the close button state

      let timer = setInterval(() => {
        setSeconds((prev) => {
          if (prev === 1) {
            clearInterval(timer);
            setShowCloseButton(true); // Enable close button after countdown
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer); // Clean up the timer
    }
  }, [ad]);

  const handleClose = () => {
    setVisible(false);
    setPlayAd({});
  };

  return (
    <>
      <Modal visible={visible} width="1000" effect="fadeInUp">
        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography id="ad-modal-title" variant="h6">
              {ad?.ad_name}
            </Typography>
            {showCloseButton ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            ) : (
              <Typography
                id="ad-modal-description"
                variant="body2"
                style={{ marginTop: "10px" }}
              >
                Ad can be close in {seconds} seconds...
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              height: "500px",
              background: "#000",
              width: "100%",
            }}
          >
            <a href={redirect_url} target="_blank" rel="noopener noreferrer">
              {isImageAd && (
                <img
                  src={ad?.ad_file}
                  alt={ad?.ad_name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "scale-down",
                  }}
                />
              )}
              {isVideoAd && (
                <ReactPlayer
                  width="100%"
                  height="100%"
                  url={ad?.ad_file}
                  playing={true}
                />
              )}
            </a>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default PlayAdModal;
